<template>
  <BaseModal ref="BaseModal" :destroyOnClose="false" @confirm="comfirm">
    <div class="change-rcj">
      <SimpleTable
        width="300px"
        :showIndex="false"
        ref="ChangeRcjLeft"
        :allowMultiSelect="false"
        table-code="ChangeRcjLeft"
        :columns="columns.left"
        :data="tableData.left"
        :loading="loading.left"
        @row-select="onRowSelectLeft"
      />
      <SimpleTable
        style="flex: 1"
        :showIndex="false"
        ref="ChangeRcjRight"
        :allowMultiSelect="multiple"
        table-code="ChangeRcjRight"
        :columns="columns.right"
        :data="tableData.right"
        :loading="loading.right"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'ChangeRcj',
  components: { BaseModal, SimpleTable },
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 页面数据
      loading: {
        left: false,
        right: false
      },
      tableData: {
        left: [],
        right: []
      },
      columns: {
        left: [{ field: 'name', title: '人材机分类' }],
        right: [
          { field: 'name', title: '人材机名称' },
          { field: 'spec', title: '规格型号' },
          { field: 'unit', title: '单位' }
        ]
      },

      selectLeft: {}
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法,

    async show(options = {}) {
      this.options = { ...options }

      this.tableData.left = []
      this.tableData.right = []

      this.$refs.BaseModal.show({
        title: '更换人材机',
        width: '1000px',
        confirmText: '确定'
      })
      this.getTableDataLeft()
    },

    async getTableDataLeft() {
      this.tableData.left = []
      this.tableData.right = []
      this.loading.left = true
      const res = await this.$service.get('/base-resource-classify/list', {})
      this.tableData.left = sortRecords(res.data || [])
      this.loading.left = false
      this.$refs.ChangeRcjLeft.initialized()
    },
    async getTableDataRight(obj) {
      this.tableData.right = []
      this.loading.right = true
      const res = await this.$service.get('/base-resource-classify/resources', {
        classifyId: obj.id
      })
      this.tableData.right = sortRecords(res.data || [])
      this.loading.right = false
    },

    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.selectLeft = obj
      this.getTableDataRight(obj)
    },

    comfirm() {
      const res = this.$refs.ChangeRcjRight.getSelectData().map(
        e => e[0].originData
      )
      if (res.length !== 1) {
        this.$message('请选中一条数据！')
        return
      }
      this.$emit(
        'comfirm',
        res.map(e => ({
          ...e,
          classifyName: this.selectLeft.name,
          classifyId: this.selectLeft.id
        }))
      )
      this.$refs.BaseModal.close()
    }
  }
}
</script>

<style scoped lang="less">
.change-rcj {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 600px;
  gap: 10px;
}
</style>
